import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from "../../../stores";
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import UploadImageDialog from "../upload/UploadImageDialog";

const EditFolderDialog = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const store = sdk.currentDialog || null;

    return (
        <Dialog
            visible={!!store}
            header={store.header}
            onHide={() => {
                sdk.closeDialog();
                // if(!store.isNewOrder) {
                //     sdk.openDialog(OrderDialogStore, { order_id: store.order_id });
                // }
            }}
            style={{ width: '40rem' }}
        >
            {store.isLoading ? (
                // Show loading spinner when managerDataLoading is true
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                <div className="p-fluid">
                    {store.hasParent && (
                        <UploadImageDialog store={store} />
                    )}
                    {/* Eingabefeld für den Ordnernamen */}
                    <div className="field">
                        <label htmlFor="folderName">Ordnername</label>
                        <InputText
                            id="folderName"
                            value={store.folderName}
                            onChange={(e) => store.folderName = e.target.value}
                            placeholder="Geben Sie den Ordnernamen ein"
                        />
                    </div>
                    {/* Eingabefeld für die Beschreibung */}
                    <div className="field">
                        <label htmlFor="folderDescription">Beschreibung</label>
                        <InputTextarea
                            id="folderDescription"
                            value={store.folderDescription}
                            onChange={(e) => store.folderDescription = e.target.value}
                            rows={3}
                            placeholder="Geben Sie eine Beschreibung ein"
                        />
                    </div>
                    {/* Checkbox für Sichtbarkeit */}
                    {store.hasParent && (
                        <div className="field-checkbox" style={{ marginTop: '1rem' }}>
                            <Checkbox
                                inputId="visibleForAll"
                                checked={store.visibleForAll}
                                onChange={(e) => store.toggleVisible()}
                            />
                            <label htmlFor="visibleForAll" style={{ marginLeft: '0.5rem' }}>Sichtbar für alle</label>
                        </div>
                    )}
                    {/* Button zum Erstellen des Auftrags */}
                    <div style={{ textAlign: 'right', marginTop: '2rem' }}>
                        <Button
                            label={store.buttonLabel}
                            icon="pi pi-check"
                            className="p-button-success"
                            disabled={!store.isValid}
                            onClick={() => {
                                store.createOrUpdateFolder().then(({ id, event }: { id: number | null, event: any }) => {
                                    if (event) {
                                        if (event?.event === 'NEW') {
                                            sdk.showSuccessToast('Ordner erfolgreich erstellt');
                                        } else if (event?.event === 'UPDATE') {
                                            sdk.showSuccessToast('Ordner erfolgreich aktualisiert');
                                        }
                                        sdk.closeDialog(event);
                                    }
                                }).catch((error: any) => {
                                    sdk.showErrorToast(error?.message || 'Unbekannter Fehler')
                                });
                            }}
                        />
                    </div>
                </div>
            )}
        </Dialog>
    );
});

export default EditFolderDialog;